/**
 * The two-letter avatar label, from the prototype's `initials`.
 *
 * A single name gives its first two letters; anything longer gives the first
 * letter of the first two words. Arabic names in the seed run to three and four
 * parts and taking one letter from each would produce a four-letter badge that
 * does not fit the circle.
 */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  const first = parts[0] ?? '';
  const second = parts[1];
  return (second === undefined ? first.slice(0, 2) : first[0]! + second[0]!).toUpperCase();
}
